import React from 'react'

export default function TaskAssignedIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.40039 1.90039H11.9004C13.0876 1.9006 14.0498 2.8635 14.0498 4.05078V11.5508C14.0496 11.6333 13.9829 11.7 13.9004 11.7002C13.8177 11.7002 13.7502 11.6334 13.75 11.5508V4.05078C13.75 3.02918 12.9219 2.20041 11.9004 2.2002H4.40039C4.31768 2.2002 4.25021 2.13344 4.25 2.05078C4.25 1.96794 4.31755 1.90039 4.40039 1.90039Z" stroke="#64617E" />
            <mask id="task-assigned-icon-rect" fill="white">
                <rect x="1.40039" y="3.54688" width="11.0098" height="11.0039" rx="1" />
            </mask>
            <rect x="1.40039" y="3.54688" width="11.0098" height="11.0039" rx="1" stroke="#64617E" strokeWidth="2.6" mask="url(#task-assigned-icon-rect)" />
            <path d="M4.77368 9.30589L5.8348 10.3682C6.02955 10.5631 6.34535 10.5638 6.54088 10.3696L9.03689 7.89062" stroke="#64617E" strokeWidth="1.3" strokeLinecap="round" />
        </svg>
    )
}
